const SINGLE_BENEFICIARIES_TABLE_HEADERS = [
  {
    name: 'Beneficiary Alias',
    column: 'alias',
    currency: 'currency'
  },
  {
    name: 'Wallet Address',
    column: 'address'
  },
  {
    name: 'Currency',
    column: 'currency_slug',
    currency: 'network'
  },
  {
    name: 'Date Created',
    column: 'created_at',
    filter: 'date'
  }
];
const BULK_BENEFICIARIES_TABLE_HEADERS = [
  {
    name: 'Beneficiary Group',
    column: 'label'
  },
  {
    name: 'Number of rows',
    column: 'row_count'
  },
  {
    name: 'Currency',
    column: 'currency_slug',
    currency: 'network'
  },
  {
    name: 'Date Created',
    column: 'created_at',
    filter: 'date'
  }
];

export { BULK_BENEFICIARIES_TABLE_HEADERS, SINGLE_BENEFICIARIES_TABLE_HEADERS };
